// Module
var code = "<gis-preview item=\"item\" map-lazy-load=\"https://maps.googleapis.com/maps/api/js?key={{ key }}\" style=\"height:calc(100vh - 40px);margin:-15px\"></gis-preview> ";
// Exports
export default code;